import { render, staticRenderFns } from "./CampsSlider.vue?vue&type=template&id=68658b22&lang=pug&"
import script from "./CampsSlider.vue?vue&type=script&lang=js&"
export * from "./CampsSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports